import { FC, useContext, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import AppContext from '../../../store/appContext';
import { Props } from '../../../interfaces/interfaces';
import AggregationMap from '../../ui/AggregationMap/AggregationMap';

const MapView: FC<Props> = (props): JSX.Element => {
  const { getWhoAmI } = useContext(AppContext);

  useEffect(() => {
    getWhoAmI();
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="top">
      <h1 className="px-3 mb-4 display-5 text-center">{props.header}</h1>
      <Container fluid>
        <AggregationMap standalone />
      </Container>
    </section>
  );
};

export default MapView;
